export default __webpack_public_path__ + "static/media/57_desktop.2e5be23d.jpg";